import React from 'react';
import PropTypes from 'prop-types';
import { Range } from 'rc-slider';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import 'rc-slider/assets/index.css';


class ResultBreakPointsSlider extends React.Component {

  get marks() {
    const {
      min,
      max,
      labelStep
    } = this.props;
    const marks = {};

    for (let i=min; i <= max; i+=labelStep) {
      marks[i] = String(i);
    }
    return marks;
  }

  render() {
    const {
      min,
      max,
      step,
      low,
      high,
      units,
      onChangeRange
    } = this.props;
    return (
      <Container>
        <Row>
        <p>Drag circles below to change and set your result ranges.</p>
        </Row>
        <Row className='mb-5'>
          <Range
            min={min}
            max={max}
            step={step}
            defaultValue={[low, high]}
            marks={this.marks}
            onChange={onChangeRange}
          />
        </Row>
        <Row className='text-center'>
          <Col>
            <strong>Low</strong>
          </Col>
          <Col>
            <strong>Borderline</strong>
          </Col>
          <Col>
            <strong>High</strong>
          </Col>
        </Row>
        <Row className='text-center'>
          <Col>{`< ${low} ${units}`}</Col>
          <Col>{`${low} - < ${high} ${units}`}</Col>
          <Col>{`>= ${high} ${units}`}</Col>
        </Row>
      </Container>
    );
  }
}

ResultBreakPointsSlider.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  labelStep: PropTypes.number,
  low: PropTypes.number,
  high: PropTypes.number,
  units: PropTypes.string,
  onChangeRange: PropTypes.func
};

ResultBreakPointsSlider.defaultProps = {
  min: 0,
  max: 10,
  step: 0.1,
  labelStep: 1
};

export default ResultBreakPointsSlider;


// WEBPACK FOOTER //
// src/components/reportManagement/ResultBreakPointsSlider/index.jsx